import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchVoyageData,
  selectVoyage,
  setDataSuccess
} from 'src/features/staticDataSlice';
import VoyageCreateModal from 'src/pages/Voyage/VoyageCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function VoyageMasterList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [voyageCreatePermission, setVoyageCreatePermission] = useState(false);

  const voyageData = useSelector(selectVoyage);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setVoyageCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('voyages', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchVoyageData(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'voyage', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-voyages" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-voyages"
          id="select-voyages"
          value={tableListDatas[index]?.voyages || ''}
          onChange={(event) => {
            handleChange('voyages', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {voyageData?.map((voyage) => (
            <MenuItem key={voyage?.voyageName} value={voyage?.voyageName}>
              {voyage?.voyageName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              voyageCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Voyage
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (voyageCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: voyageCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <VoyageCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default VoyageMasterList;
